<template>
  <div class="leftItem" style="color: #fff;">
    <populationBaseInfo />
    <healthManagement />
    <contractMessage />
  </div>
</template>

<script>
export default {
  components: {
    populationBaseInfo: () => import('./component/populationBaseInfo.vue'),
    healthManagement: () => import('./component/healthManagement.vue'),
    contractMessage: () => import('./component/contractMessage.vue'),
  },
}
</script>

<style scoped></style>
